import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE = `${BACKEND_URL}/api/setting`;

const getExclusionsByWebsite = (websiteId) =>
  axios.get(`${BASE}/website/${websiteId}/exclusions`);

const addExclusion = (websiteId, customerId) =>
  axios.post(`${BASE}/website/${websiteId}/exclusions`, { customerId });

const removeExclusion = (websiteId, customerId) =>
  axios.delete(`${BASE}/website/${websiteId}/exclusions/${customerId}`);

const getExclusionsByCustomer = (customerId) =>
  axios.get(`${BASE}/website-fee-exclusions/customer/${customerId}`);

export default { getExclusionsByWebsite, addExclusion, removeExclusion, getExclusionsByCustomer };
